import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useUtmTaxonomyStore } from '@/store/utm-taxonomy-store';
import UtmCategoryList from '@/components/utm/admin/categories/UtmCategoryList';
import UtmCategoryForm from '@/components/utm/admin/categories/UtmCategoryForm';

const UtmCategoriesPage = () => {
  const { fetchTaxonomy } = useUtmTaxonomyStore();

  useEffect(() => {
    fetchTaxonomy();
  }, [fetchTaxonomy]);

  return (
    <Routes>
      <Route index element={<UtmCategoryList />} />
      <Route path="new" element={<UtmCategoryForm />} />
      <Route path=":id/edit" element={<UtmCategoryForm />} />
    </Routes>
  );
};

export default UtmCategoriesPage;
